import { z } from 'zod'

export const performanceQuartileMetricsSchema = z.object({
  pr25: z.number().nullable(),
  pr50: z.number().nullable(),
  pr75: z.number().nullable(),
})

export type PerformanceQuartileMetrics = z.infer<
  typeof performanceQuartileMetricsSchema
>
